import React, {useEffect, useId, useState} from 'react';
import {useSelector} from 'react-redux';

import PopupSticked from '@/components/Popup/PopupSticked';
import amplitudeModalsTracking from '@/services/analytics/amplitude/amplitudeModalsTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import appErrorService from '@/services/app/appErrorService';
import feedbackPopupService from '@/services/feedbackPopupService';
import modalService from '@/services/modalService';
import {selectConsumerId} from '@/state/selectors/consumer';

import FeedbackPopupContent from './components/FeedbackPopupContent';
import ThanksPopupContent from './components/ThanksPopupContent';
import consumerFeedbackGatheringService from './consumerFeedbackGatheringService';

const ConsumerFeedbackGatheringPopup = ({modalType}) => {
    const headerId = useId();
    const consumerId = useSelector(selectConsumerId);
    const [isThanksPopupVisible, setIsThanksPopupVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        amplitudeModalsTracking.trackFeedbackPopupViewed();
        googleAnalyticsService.trackFeedbackPopupViewed();
    }, []);

    const onClose = () => {
        modalService.hideModal(modalType);
        if (!isThanksPopupVisible) {
            feedbackPopupService.handleFeedbackClosing();
        }
    };

    const onSubmit = async (data) => {
        setIsLoading(true);
        await consumerFeedbackGatheringService.uploadFeedbackData({data, consumerId, onSuccess, onError});
        setIsLoading(false);
    };

    const onSuccess = () => {
        amplitudeModalsTracking.trackFeedbackSubmitted(true);
        googleAnalyticsService.trackFeedbackSubmitted(true);
        setIsThanksPopupVisible(true);
        feedbackPopupService.setDoNotShowAnymore();
    };

    const onError = () => {
        amplitudeModalsTracking.trackFeedbackSubmitted(false);
        googleAnalyticsService.trackFeedbackSubmitted(false);
        appErrorService.showGlobalError();
    };

    const onBackButtonClick = () => {
        onClose();
    };

    return (
        <PopupSticked
            className='flex flex-col items-center rounded-t-xl bg-romance px-6 pt-14 ml:max-h-[calc(100%-92px-var(--hw-h))] ml:w-[457px] ml:max-w-[568px] ml:rounded-3xl ml:pt-16'
            onClose={onClose}
            isCloseVisible
            closeButtonClass='right-3 top-3 ml:right-4 ml:top-4'
            aria-labelledby={headerId}
        >
            {isThanksPopupVisible ? (
                <ThanksPopupContent headerId={headerId} onBackButtonClick={onBackButtonClick} />
            ) : (
                <FeedbackPopupContent headerId={headerId} onSubmit={onSubmit} isLoading={isLoading} />
            )}
        </PopupSticked>
    );
};

export default ConsumerFeedbackGatheringPopup;
